export default "__VITE_ASSET__tC9nPTNs__"